import React, { FC } from 'react';

type IProps = {
    htmlFor: string;
    innerText: string;
};
const InputLabel: FC<IProps> = ({ htmlFor, innerText }) => (
    <label htmlFor={htmlFor} className="label-style">
        {innerText}
    </label>
);

export default InputLabel;
